// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/piano/PianoScreens.css */

/* --- ОБЩИЙ ОВЕРЛЕЙ ДЛЯ ВСЕХ ЭКРАНОВ --- */
.piano-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  animation: pianoFadeIn 0.3s ease-out;
  padding: 20px;
  box-sizing: border-box;
}

@keyframes pianoFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* --- КАРТОЧКА (ОСНОВНОЙ КОНТЕЙНЕР) --- */
.piano-card {
  width: 100%;
  max-width: 360px;
  background: linear-gradient(145deg, #1e1e24, #1a1a20);
  border: 2px solid #333;
  border-top: 4px solid #fbbf24; /* Золотой верх */
  border-radius: 8px;
  padding: 25px 20px;
  box-shadow:
    0 10px 30px rgba(0,0,0,0.8),
    0 0 0 1px rgba(255,255,255,0.05);
  text-align: center;
  position: relative;
  transform: rotate(-1deg); /* Легкий наклон как у досье */
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
}

/* Декоративный фон (ноты) */
.piano-card::before {
  content: '♪ ♫ ♩';
  position: absolute;
  top: 10px; left: 10px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.03);
  font-weight: 900;
  letter-spacing: 5px;
  pointer-events: none;
}

/* --- ЗАГОЛОВКИ --- */
.pc-title {
  font-family: 'Courier New', monospace;
  font-size: 24px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #fbbf24;
  margin-bottom: 10px;
  text-shadow: 0 2px 10px rgba(251, 191, 36, 0.2);
}

.pc-subtitle {
  font-size: 14px;
  color: #94a3b8;
  margin-bottom: 20px;
  line-height: 1.5;
}

/* --- ИКОНКИ --- */
.pc-icon-wrapper {
  margin: 15px 0 25px;
  font-size: 50px;
  color: #f1f5f9;
  filter: drop-shadow(0 0 15px rgba(255,255,255,0.1));
  animation: pcFloat 3s ease-in-out infinite;
}

@keyframes pcFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

/* --- РЕЗУЛЬТАТ РАУНДА (STATUS) --- */
.pc-status-text {
  font-size: 32px;
  font-weight: 900;
  text-transform: uppercase;
  margin: 10px 0;
  letter-spacing: 1px;
}

.status-perfect { color: #4ade80; text-shadow: 0 0 15px rgba(74, 222, 128, 0.3); }
.status-good { color: #fbbf24; }
.status-fail { color: #ef4444; }

.pc-points-badge {
  background: rgba(255,255,255,0.08);
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  display: inline-block;
  border: 1px solid rgba(255,255,255,0.1);
}
.pc-points-badge.positive { color: #4ade80; border-color: #4ade80; }
.pc-points-badge.negative { color: #ef4444; border-color: #ef4444; }

/* --- СТАТИСТИКА (ФИНАЛ) --- */
.pc-stats-grid {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
  background: rgba(0,0,0,0.2);
  padding: 15px;
  border-radius: 6px;
  border: 1px solid rgba(255,255,255,0.05);
}

.pc-stat-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  padding-bottom: 5px;
}
.pc-stat-row:last-child { border-bottom: none; }

.pc-stat-label {
  font-size: 12px;
  text-transform: uppercase;
  color: #888;
  font-weight: bold;
}
.pc-stat-value {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  font-family: 'Courier New', monospace;
}
.pc-stat-value.gold { color: #fbbf24; }

/* --- КНОПКИ --- */
.pc-btn-group {
  display: flex;
  gap: 12px;
  width: 100%;
}

.pc-btn {
  flex: 1 1;
  border: none;
  padding: 14px 0;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 900;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #1a1a1a;
  box-shadow: 0 4px 0 rgba(0,0,0,0.3);
}

.pc-btn:active {
  transform: translateY(2px);
  box-shadow: 0 2px 0 rgba(0,0,0,0.3);
}

.pc-btn.primary {
  background: #fbbf24; /* Золотой */
  color: #1a1a20;
}
.pc-btn.primary:hover { background: #f59e0b; }

.pc-btn.secondary {
  background: #334155;
  color: #cbd5e1;
  box-shadow: 0 4px 0 #1e293b;
}
.pc-btn.secondary:hover { background: #475569; }

.pc-btn.full-width { width: 100%; }

/* --- ЛИДЕРБОРД ВНУТРИ КАРТОЧКИ --- */
.piano-card .unified-leaderboard {
  background: rgba(0,0,0,0.25);
  border: 1px solid rgba(255,255,255,0.05);
  margin-top: 0;
  margin-bottom: 15px;
}
.piano-card .unified-leaderboard .ul-title {
  color: #888;
  font-size: 11px;
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/piano/PianoScreens.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,gBAAgB;EAChB,qDAAqD;EACrD,sBAAsB;EACtB,6BAA6B,EAAE,iBAAiB;EAChD,kBAAkB;EAClB,kBAAkB;EAClB;;oCAEkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB,EAAE,8BAA8B;EACxD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS,EAAE,UAAU;EACrB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mDAAmD;EACnD,0CAA0C;AAC5C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB,cAAc,EAAE,6CAA6C,EAAE;AACjF,eAAe,cAAc,EAAE;AAC/B,eAAe,cAAc,EAAE;;AAE/B;EACE,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;AACzC;AACA,4BAA4B,cAAc,EAAE,qBAAqB,EAAE;AACnE,4BAA4B,cAAc,EAAE,qBAAqB,EAAE;;AAEnE,+BAA+B;AAC/B;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qCAAqC;AACvC;AACA,sBAAsB,cAAc,EAAE;;AAEtC,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB,EAAE,YAAY;EACjC,cAAc;AAChB;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C,qBAAqB,WAAW,EAAE;;AAElC,sCAAsC;AACtC;EACE,4BAA4B;EAC5B,wCAAwC;EACxC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* games/piano/PianoScreens.css */\r\n\r\n/* --- ОБЩИЙ ОВЕРЛЕЙ ДЛЯ ВСЕХ ЭКРАНОВ --- */\r\n.piano-overlay {\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: rgba(0, 0, 0, 0.85);\r\n  backdrop-filter: blur(5px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 50;\r\n  animation: pianoFadeIn 0.3s ease-out;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n@keyframes pianoFadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n/* --- КАРТОЧКА (ОСНОВНОЙ КОНТЕЙНЕР) --- */\r\n.piano-card {\r\n  width: 100%;\r\n  max-width: 360px;\r\n  background: linear-gradient(145deg, #1e1e24, #1a1a20);\r\n  border: 2px solid #333;\r\n  border-top: 4px solid #fbbf24; /* Золотой верх */\r\n  border-radius: 8px;\r\n  padding: 25px 20px;\r\n  box-shadow:\r\n    0 10px 30px rgba(0,0,0,0.8),\r\n    0 0 0 1px rgba(255,255,255,0.05);\r\n  text-align: center;\r\n  position: relative;\r\n  transform: rotate(-1deg); /* Легкий наклон как у досье */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  color: #fff;\r\n}\r\n\r\n/* Декоративный фон (ноты) */\r\n.piano-card::before {\r\n  content: '♪ ♫ ♩';\r\n  position: absolute;\r\n  top: 10px; left: 10px;\r\n  font-size: 24px;\r\n  color: rgba(255, 255, 255, 0.03);\r\n  font-weight: 900;\r\n  letter-spacing: 5px;\r\n  pointer-events: none;\r\n}\r\n\r\n/* --- ЗАГОЛОВКИ --- */\r\n.pc-title {\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 24px;\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  letter-spacing: 2px;\r\n  color: #fbbf24;\r\n  margin-bottom: 10px;\r\n  text-shadow: 0 2px 10px rgba(251, 191, 36, 0.2);\r\n}\r\n\r\n.pc-subtitle {\r\n  font-size: 14px;\r\n  color: #94a3b8;\r\n  margin-bottom: 20px;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* --- ИКОНКИ --- */\r\n.pc-icon-wrapper {\r\n  margin: 15px 0 25px;\r\n  font-size: 50px;\r\n  color: #f1f5f9;\r\n  filter: drop-shadow(0 0 15px rgba(255,255,255,0.1));\r\n  animation: pcFloat 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes pcFloat {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-8px); }\r\n}\r\n\r\n/* --- РЕЗУЛЬТАТ РАУНДА (STATUS) --- */\r\n.pc-status-text {\r\n  font-size: 32px;\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  margin: 10px 0;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.status-perfect { color: #4ade80; text-shadow: 0 0 15px rgba(74, 222, 128, 0.3); }\r\n.status-good { color: #fbbf24; }\r\n.status-fail { color: #ef4444; }\r\n\r\n.pc-points-badge {\r\n  background: rgba(255,255,255,0.08);\r\n  padding: 6px 14px;\r\n  border-radius: 20px;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  margin-bottom: 20px;\r\n  display: inline-block;\r\n  border: 1px solid rgba(255,255,255,0.1);\r\n}\r\n.pc-points-badge.positive { color: #4ade80; border-color: #4ade80; }\r\n.pc-points-badge.negative { color: #ef4444; border-color: #ef4444; }\r\n\r\n/* --- СТАТИСТИКА (ФИНАЛ) --- */\r\n.pc-stats-grid {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n  background: rgba(0,0,0,0.2);\r\n  padding: 15px;\r\n  border-radius: 6px;\r\n  border: 1px solid rgba(255,255,255,0.05);\r\n}\r\n\r\n.pc-stat-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: baseline;\r\n  border-bottom: 1px solid rgba(255,255,255,0.1);\r\n  padding-bottom: 5px;\r\n}\r\n.pc-stat-row:last-child { border-bottom: none; }\r\n\r\n.pc-stat-label {\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  color: #888;\r\n  font-weight: bold;\r\n}\r\n.pc-stat-value {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  color: #fff;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n.pc-stat-value.gold { color: #fbbf24; }\r\n\r\n/* --- КНОПКИ --- */\r\n.pc-btn-group {\r\n  display: flex;\r\n  gap: 12px;\r\n  width: 100%;\r\n}\r\n\r\n.pc-btn {\r\n  flex: 1;\r\n  border: none;\r\n  padding: 14px 0;\r\n  border-radius: 6px;\r\n  font-size: 16px;\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  color: #1a1a1a;\r\n  box-shadow: 0 4px 0 rgba(0,0,0,0.3);\r\n}\r\n\r\n.pc-btn:active {\r\n  transform: translateY(2px);\r\n  box-shadow: 0 2px 0 rgba(0,0,0,0.3);\r\n}\r\n\r\n.pc-btn.primary {\r\n  background: #fbbf24; /* Золотой */\r\n  color: #1a1a20;\r\n}\r\n.pc-btn.primary:hover { background: #f59e0b; }\r\n\r\n.pc-btn.secondary {\r\n  background: #334155;\r\n  color: #cbd5e1;\r\n  box-shadow: 0 4px 0 #1e293b;\r\n}\r\n.pc-btn.secondary:hover { background: #475569; }\r\n\r\n.pc-btn.full-width { width: 100%; }\r\n\r\n/* --- ЛИДЕРБОРД ВНУТРИ КАРТОЧКИ --- */\r\n.piano-card .unified-leaderboard {\r\n  background: rgba(0,0,0,0.25);\r\n  border: 1px solid rgba(255,255,255,0.05);\r\n  margin-top: 0;\r\n  margin-bottom: 15px;\r\n}\r\n.piano-card .unified-leaderboard .ul-title {\r\n  color: #888;\r\n  font-size: 11px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
